import { render, staticRenderFns } from "./seach.vue?vue&type=template&id=4b6bee0a&scoped=true&"
import script from "./seach.vue?vue&type=script&lang=js&"
export * from "./seach.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b6bee0a",
  null
  
)

export default component.exports